import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "home-page" }
const _hoisted_2 = { class: "top-banner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "info" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "search-section" }
const _hoisted_8 = { class: "search-container" }
const _hoisted_9 = { class: "main-content" }
const _hoisted_10 = { class: "table-section" }
const _hoisted_11 = { class: "table-container" }
const _hoisted_12 = { class: "data-table" }
const _hoisted_13 = { class: "col-type" }
const _hoisted_14 = { class: "col-name" }
const _hoisted_15 = { class: "col-publisher" }
const _hoisted_16 = { class: "col-time" }
const _hoisted_17 = { class: "col-status" }
const _hoisted_18 = { class: "col-info" }
const _hoisted_19 = { class: "col-link" }
const _hoisted_20 = ["href"]

import { ref, onMounted } from 'vue'
import { getLawList } from '@/apis/index'
import { showToast } from 'vant'
import { baseUrl } from '@/utils'
// 表格数据

export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const tableData = ref([])

const keyword = ref('')

const getList = async () => {
  const res = await getLawList({
    file_category_type: '法规',
    keyword: keyword.value,
    page: 1,
    pageSize: 10,
    search_type: '智能检索'
  })

  console.log(123, res)
  tableData.value = res.result
}

const showMessage = () => {
  showToast({
    message: '联系客服邮箱\nservice@msecu.com',
    position: 'top'
  })
}

onMounted(() => {
  getList()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(baseUrl) + '/banner1.png',
        alt: "Banner",
        class: "banner-image"
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          src: _unref(baseUrl) + '/logo2.png',
          class: "logo",
          alt: ""
        }, null, 8, _hoisted_5),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "label" }, "医疗器械注册辅助工具", -1)),
        _createElementVNode("img", {
          src: _unref(baseUrl) + '/btn.png',
          class: "btn",
          alt: ""
        }, null, 8, _hoisted_6)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
          type: "text",
          class: "search-input",
          placeholder: "输入关键词搜索相关法规、标准、指导原则"
        }, null, 512), [
          [_vModelText, keyword.value]
        ]),
        _createElementVNode("button", {
          class: "search-button",
          onClick: getList
        }, "立即搜索")
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("table", _hoisted_12, [
            _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { class: "col-type" }, "文件类型"),
                _createElementVNode("th", { class: "col-name" }, "文件名称"),
                _createElementVNode("th", { class: "col-publisher" }, "发布机构"),
                _createElementVNode("th", { class: "col-time" }, "发布时间"),
                _createElementVNode("th", { class: "col-status" }, "生效状态"),
                _createElementVNode("th", { class: "col-info" }, "信息类型"),
                _createElementVNode("th", { class: "col-link" }, "网页链接")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_13, _toDisplayString(item.file_category), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(item.file_name), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(item.medical_file_publish_orgnization), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(item.medical_file_publish_date ? item.medical_file_publish_date.substring(0, 10) : ''), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(item.medical_file_law_status), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(item.regulation_file_type), 1),
                  _createElementVNode("td", _hoisted_19, [
                    _createElementVNode("a", {
                      href: item.medical_file_website_link,
                      target: "_blank",
                      class: "link"
                    }, _toDisplayString(item.medical_file_website_link), 9, _hoisted_20)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", { class: "table-footer" }, [
          _cache[3] || (_cache[3] = _createTextVNode(" 当前显示10条结果，登陆后可查看更多数据，")),
          _createElementVNode("a", {
            href: "javascript: void(0)",
            onClick: showMessage,
            class: "more-link"
          }, "立即登录")
        ])
      ])
    ])
  ]))
}
}

})